// utils/confirm.js
import Swal from "sweetalert2";

export async function confirmSwal({
    title = "Are you sure?",
    text = "",
    confirmText = "Yes",
    cancelText = "Cancel",
    icon = "warning",
    confirmColor = "#d33",
} = {}) {
    const { isConfirmed } = await Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        confirmButtonColor: confirmColor,
    });
    return isConfirmed;
}
